import { render, staticRenderFns } from "./PromoterStatisticsList.component.vue?vue&type=template&id=21de2773"
import script from "./PromoterStatisticsList.component.vue?vue&type=script&lang=ts"
export * from "./PromoterStatisticsList.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports